(function ($, Cobalt, undefined) {
    Cobalt.CPCaching =
    {
        initialize: function () {
            $(".j-stats").each(function (i, val) {
                var host = $(val).attr("data-host");
                var url = "/api/get-cache-stats-for-server?host=" + host;
                var apiKey = $(val).attr("data-apikey");
                $.ajax({
                    type: "POST",
                    dataType: "json",
                    beforeSend: function (request) {
                        request.setRequestHeader("Access-Control-Request-Headers", "x-requested-with");
                        request.setRequestHeader("apikey", apiKey);
                        $(val).mask();
                    },
                    url: url,
                    success: function (data) {
                        if (data.Status === "Success") {
                            var ul = $(val).find("ul");
                            ul.prepend(data.Html);
                        }
                        $(val).unmask();
                    }
                });
            });
        }
    };
})(jQuery, Cobalt);


// WEBPACK FOOTER //
// ./content/js/Cobalt/Cobalt.CPCaching.js